import { render } from "./DropdownButton.vue?vue&type=template&id=9d4d6e5a&scoped=true"
import script from "./DropdownButton.vue?vue&type=script&lang=ts"
export * from "./DropdownButton.vue?vue&type=script&lang=ts"

import "./DropdownButton.vue?vue&type=style&index=0&id=9d4d6e5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9d4d6e5a"

export default script